import { render, staticRenderFns } from "./section-gox-born.vue?vue&type=template&id=d76a1d5e&scoped=true"
import script from "./section-gox-born.vue?vue&type=script&lang=js"
export * from "./section-gox-born.vue?vue&type=script&lang=js"
import style0 from "./section-gox-born.vue?vue&type=style&index=0&id=d76a1d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76a1d5e",
  null
  
)

export default component.exports